<script setup lang="ts">
    export interface Props {
        label: string;
        optional?: boolean;
        optionalText?: string;
        size?: string;
        inputId?: string;
        showLabel?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        optional: false,
        optionalText: 'optional',
        size: 'fixed',
        showLabel: true,
    });

    /**
     * inputs in modals need to be a bit smaller than inputs in forms
     */
    const inputMinWidth = props.size === 'fluid' ? '320px' : '380px';
    const inputWidth = props.size === 'fluid' ? '100%' : 'inherit';
    const inputCursor = props.inputId ? 'pointer' : 'inherit';
</script>

<template>
    <div class="form-group">
        <div v-show="showLabel" class="form-group-label">
            <label :for="inputId">{{ label }}</label>
            <div v-if="optional" class="form-group-optional">({{ optionalText }})</div>
        </div>
        <div class="form-group-content w-100">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .form-group {
        display: flex;
        align-items: center;
        margin: 20px 0;

        &:has(.custom-text-field),
        &:has(.v-select) {
            align-items: flex-start;

            .form-group-label {
                padding-top: 10px;

                &:has(.form-group-optional) {
                    padding-top: 0;
                }
            }
        }
    }

    .form-group-label {
        font-size: 16px;
        line-height: 1.45;
        color: rgb(var(--v-theme-secondary-text));
        min-width: 160px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        label {
            cursor: v-bind('inputCursor');
        }
    }

    .form-group-optional {
        color: rgb(var(--v-theme-primary));
        font-weight: 600;
        font-size: 14px;
        line-height: 1.45;
    }

    .form-group-content {
        min-width: v-bind('inputMinWidth');
        width: v-bind('inputWidth');
        display: flex;
        align-items: center !important;
    }

    @media screen and (max-width: 980px) {
        .form-group-label {
            min-width: 120px;
        }

        .form-group-content {
            min-width: 240px;
        }
    }

    @media screen and (max-width: 820px) {
        .form-group {
            display: flex;
            flex-wrap: wrap;
        }
    }
</style>
